import { createFileRoute, Outlet } from "@tanstack/react-router";

interface PresentationsSearch {
  id?: string;
}

export const Route = createFileRoute("/_authenticated/presentations")({
  validateSearch: (search: Record<string, unknown>): PresentationsSearch => ({
    id: typeof search.id === "string" ? search.id : undefined,
  }),
  component: PresentationsLayoutRoute,
});

function PresentationsLayoutRoute() {
  return <Outlet />;
}
